module.exports = __webpack_public_path__ + "static/media/Opening-Procedures.06103303.pdf";